module.exports = __webpack_public_path__ + "img/shuttle_partner_logo_purple.e2e3e9d4.png";